/* eslint-disable no-undef */
import axios from 'axios';
import { getToken } from 'utils/helpers';
import history from 'utils/history';
import { ROUTES } from 'constants/AppRoutes';

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance =  axios.create({
    baseURL: baseUrl,
    withCredentials: false,
    crossDomain: true,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'x-knetikcloud-appid': 'cuentas'
    }
})
axiosInstance.interceptors.request.use(function (config) {
    const token = getToken();
    config.headers.Authorization =  token ? `Bearer ${ token }` :  '' ;
    return config;
});

axiosInstance.interceptors.response.use((response) => {
    if (response.data && response.data.error) {
        return Promise.reject(response);
    }
    return response;
}, (error) => {
    if(error.response.status === 401){
        history.push(ROUTES.SIGNUP)
        //return Promise.reject(error);
    }
    if(!error.response) {
        // notification(NOTIFICATION_TYPES.ERROR, error.message)
        return Promise.reject(error);
    }
    return Promise.reject(error);
});

export default axiosInstance;
